/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const IconDropdownDown2 = ({ className }) => {
  return (
    <svg
      className={`icon-dropdown-down-2 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M7.5 9L12.1661 14.0397L17.2 9"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};
